/*global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { PureComponent } from 'react';
import moment from 'moment';

import '../styles/ProjectCardSummary.css';

export default
class OrganizationCardSummary extends PureComponent {
  static propTypes = {
    accountCount: PropTypes.string,
    projectCount: PropTypes.string,
    creator: PropTypes.string,
    createdAt: PropTypes.string,
  };

  render() {
    const {
      projectCount,
      accountCount,
    } = this.props;

    let createdAt = (this.props.createdAt)
      ? moment(this.props.createdAt).format('MMM DD, YYYY')
      : 'N/A';

    return (
      <div className="project-details">
        <ul className="list-group">
          <li className="d-flex align-items-center list-group-item justify-content-between">
            Accounts
            <span className="badge badge-pill badge-secondary">{accountCount}</span>
          </li>
          <li className="d-flex align-items-center list-group-item justify-content-between">
            Projects
            <span className="badge badge-pill badge-secondary">{projectCount}</span>
          </li>
          <li className="d-flex align-items-center list-group-item justify-content-between">
            Creation Date
            <span className="badge badge-pill badge-secondary">{createdAt}</span>
          </li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OrganizationCardSummary.js